import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type { AccountExtension as AccountModel } from 'tio-data/data/resources/account.ext';
import type SessionContextService from 'tio-employee/services/session-context';
import { fetchLinkingInfoRequest } from 'tio-data/requests/account';

export default class AuthenticatedSyfLinkingConfirmationRoute extends Route {
  @service declare store: Store;
  @service declare sessionContext: SessionContextService;

  async model({ institution_id }: { institution_id: string }) {
    // By the time we get to this step the account is already linked.
    // This call can be used to get information about the last step.
    const response = await this.store.request(
      // Authenticated routes guarantee user.id is set at runtime; the
      // model field is typed string | null because UserModel can also
      // represent the empty session-context placeholder.
      fetchLinkingInfoRequest(this.sessionContext.user.id as string, institution_id, 2)
    );
    const linkedAccountData = response.content as { id: string };

    const { content } = (await this.store.request(
      findRecord<AccountModel>('account', linkedAccountData.id, {
        include: 'loans,financial-institution',
        reload: true,
      })
    )) as { content: { data: AccountModel } };
    return content.data;
  }
}
